import React, {useState, useEffect, useRef} from "react";
import * as palette from "../Variables";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Placeholder from "../img/placeholder.jpg";
import styled from "styled-components";
import WorkHero from "../components/WorkHero";
import Insight from "../components/Insight";
import Competitor from "../components/Competitor";
import PainPoint from "../components/PainPoint";
import StickyNav from "../components/StickyNav";
import Persona from "../components/Persona";
import WorkRecommendation from "../components/WorkRecommendation";
import HeroImgDesktop from "../img/smart-home/smart-home-hero-desktop.png";
import HeroImgMobile from "../img/smart-home/smart-home-hero-mobile.png";
import DesignProcess from "../img/design-process.png";
import TargetAudiencePink from "../img/target-audience-pink.png";
import TargetAudienceOrange from "../img/target-audience-orange.png";
import TargetAudienceBlue from "../img/target-audience-blue.png";
import UserJourney from "../img/smart-home/smart-home-user-journey.png";
import Sketches from "../img/smart-home/smart-home-sketches.jpg";
import Final from "../img/smart-home/smart-home-final.jpg";
import Persona1 from "../img/smart-home/smart-home-persona-1.jpg";
import DignifiThumbnail from "../img/dignifi/dignifi-thumbnail.png";
import SouthwestThumbnail from "../img/southwest/southwest-thumbnail.png";
import InsightThumbnail from "../img/insight/insight-thumbnail.jpg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { faAward } from '@fortawesome/free-solid-svg-icons';


const WorkSection = styled.section`
    padding-top: 44px;
    padding-bottom: 44px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    flex-flow: column nowrap;
    row-gap: 44px;

    &.grey {
        background-color: ${palette.neutral2};
    }

    &.challenge {
        background: ${palette.gradientMain};

        p, h2 {
            color: ${palette.neutral1};
        }

        p.description {
            font-size: 22px;
        }
    }

    .work-recommendation-container {
        width: 100%;

        @media (min-width: 400px) {
            width: 48%;
        }

        @media (min-width: 650px) {
            width: 32%;
        }
    }

    a:focus-visible {
        outline: 3px solid ${palette.blueMain};
        outline-offset: 8px;
        border-radius: 4px;
    }

    .container.main-container {
        @media (min-width: 1200px) {
            margin-left: 250px;
        }

        @media (min-width: 1600px) {
            margin-left: auto;
        }
    }

    &.reflections {
        background: ${palette.blueMain};

        .label, .h3, p.h4, p {
            color: ${palette.neutral1};
        }

        .summary {
            margin-bottom: 40px;
        }
    }

    .no-left-padding, .no-right-padding {
        padding-left: 0;
        padding-right: 0;
    }

    .h3, .section-title {
        margin-bottom: 16px;
    }

    .img-caption {
        color: ${palette.neutral9};
        margin-bottom: 0 !important;
        margin-top: 16px;

        &.margin-bottom-16 {
            margin-bottom: 16px !important;
        }
    }

    img {
        border-radius: 8px;
    }

    img.placeholder {
        aspect-ratio: 2/1;
    }

    .work-recommendation-container.left {

        @media (min-width: 576px) {
            padding-right: 24px;
        }
    }

    .work-recommendation-container.middle {

        @media (min-width: 576px) {
            padding-left: 24px;
        }

        @media (min-width: 992px) {
            padding-left: 12px;
            padding-right: 12px;
        }
    }

    .work-recommendation-container.right {

        display: none;

        @media (min-width: 992px) {
            display: block;
            padding-left: 24px;
        }
    }

    @media (min-width: 768px) {
        padding-top: 72px;
        padding-bottom: 72px;
        padding-left: 24px;
        padding-right: 24px;
        row-gap: 72px;

        .no-left-padding {
            padding-left: 0;
        }

        .no-right-padding {
            padding-right: 0;
        }

        .h3, .section-title {
            margin-bottom: 24px;
        }
    }

    @media (min-width: 1200px) {
        &.first {
            margin-top: -456px;
        }
    }

    @media (min-width: 1300px) {
        &.first {
            margin-top: -456px;
        }
    }

    @media (min-width: 1400px) {
        &.first {
            margin-top: -456px;
        }
    }

    .work-elements {
        row-gap: 24px;
        display: flex;
        flex-flow: column nowrap;

        &.overview {
            h1 {
                margin-bottom: 12px;
            }
        }

        @media (min-width: 768px) {
            row-gap: 52px;

            &.overview {
                h1 {
                    margin-bottom: 24px;
                }
            }
        }

        @media (min-width: 1200px) {
            max-width: 850px;
        }

        @media (min-width: 1250px) {
            max-width: 900px;
        }

        @media (min-width: 1300px) {
            max-width: 940px;
        }

        @media (min-width: 1400px) {
            max-width: 1040px;
        }

        @media (min-width: 1500px) {
            max-width: 1096;
        }


        .neutral-9 {
            color: ${palette.neutral9};
        }

        .competitors-container {
            display: flex;
            flex-flow: row wrap;
            column-gap: 20px;
            row-gap: 16px;

            @media (min-width: 768px) {
                column-gap: 60px;
                row-gap: 24px;
            }
        }

        .insights-container {
            display: flex;
            flex-flow: column nowrap;
            row-gap: 28px;
        }

        .pain-points-container {
            row-gap: 20px;
            display: flex;
            flex-flow: column nowrap;

            @media (min-width: 768px) {
                row-gap: 32px;
            }
        }

        .left {
            @media (min-width: 768px) {
                padding-right: 24px;
            }
        }

        .right {
            @media (min-width: 768px) {
                padding-left: 24px;
            }
        }

        h3.audience1 {
            margin-bottom: 12px;

            @media (min-width: 768px) {
                margin-top: 0;
                margin-bottom: 16px;
            }
        }

        h3.audience2 {
            margin-top: 40px;
            margin-bottom: 12px;
            
            @media (min-width: 768px) {
                margin-top: 0;
                margin-bottom: 16px;
            }
        }
    }

    .personas-container {
        display: flex;
        flex-flow: column nowrap;
        row-gap: 40px;

        @media (min-width: 768px) {
            row-gap: 64px;
        }
    }
`;

const persona1Demographics = (
    <div>
        <p style={{marginBottom: 4}}><span>Age: </span>28 years old<br/></p>
        <p style={{marginBottom: 4}}><span>Occupation: </span>Junior Embedded Systems Engineer<br/></p>
        <p style={{marginBottom: 4}}><span>Location: </span>Austin, Texas<br/></p>
    </div>
);

const persona1Interests = (
    <ul>
        <li>IoT security trends</li>
        <li>Open-source development tools</li>
        <li>Attending industry conferences and webinars</li>
    </ul>
);

const persona1Aspirations = (
    <ul>
        <li>"I need to deliver high-performance products with minimal power consumption."</li>
        <li>"I'd like to future-proof my designs by choosing scalable platforms."</li>
        <li>"It's important to me that I streamline development workflows to spend more time on innovation."</li>
    </ul>
);

const persona1Frustrations = (
    <ul>
        <li>Confusing or poorly documented middleware that slows him down</li>
        <li>Having to reinvent the wheel for secure communication protocols</li>
        <li>Integrating new wireless standards like Matter without full documentation</li>
    </ul>
);

const SmartHomeInfographic = () => {
    const [scrollY, setScrollY] = useState(window.scrollY);
    
    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const getScrollMarginTop = (ref) => {
        if (!ref.current) return 0;
        const sectionTop = ref.current.getBoundingClientRect().top + window.scrollY;
        return sectionTop > scrollY ? 0 : 135;
    };

    const overviewRef = useRef(null);
    const generalResearchRef = useRef(null);
    const userResearchRef = useRef(null);
    const challengeRef = useRef(null);
    const analysisRef = useRef(null);
    const iterationsRef = useRef(null);
    const finalDesignRef = useRef(null);
    const reflectionsRef = useRef(null);

    const [showHeader, setShowHeader] = useState(true);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1200);
    const lastScrollY = useRef(window.scrollY);

    useEffect(() => {
        const handleScroll = () => {
        const currentScrollY = window.scrollY;
        const isScrollingUp = currentScrollY < lastScrollY.current;
        const isAtTop = currentScrollY < 10;
        const threshold = isDesktop ? 135 : 66;

        if (isScrollingUp || isAtTop) {
            setShowHeader(true);
        } else if (currentScrollY > threshold) {
            setShowHeader(false);
        }
        lastScrollY.current = currentScrollY;
    };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isDesktop]);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 1200);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const stickyBase = 72;
    const headerHeight = isDesktop ? 135 : 66;
    const stickyOffset = showHeader ? stickyBase + headerHeight : stickyBase;

    const [matches, setMatches] = useState(
        window.matchMedia("(min-width: 768px)").matches
    )

    useEffect(() => {
        window
        .matchMedia("(min-width: 768px)")
        .addEventListener('change', e => setMatches( e.matches ));
    }, []);


        <div >
        {matches && (<h1>Big Screen</h1>)}
        {!matches && (<h3>Small Screen</h3>)}
        </div>

    return (
        <main>

            <WorkHero src={HeroImgDesktop} alt={"Mobile and desktop views of the Renesas Smart Home infographic"} className={"d-none d-lg-block"}></WorkHero>
            <WorkHero src={HeroImgMobile} alt={"Mobile and desktop views of the Renesas Smart Home infographic"} className={"d-lg-none"}></WorkHero>
            <div className={"page-container"}>
                <StickyNav headerOffset={stickyOffset} />
                <WorkSection className={"first"} id="overview" ref={overviewRef} style={{scrollMarginTop: getScrollMarginTop(overviewRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements overview"}>
                                    <div>
                                        <h1 className={"h2"}>Renesas Smart Home interactive infographic</h1>
                                        <p><span className={"semibold"}>Timeline / </span>March 2024</p>
                                        <p><span  className={"semibold"}>Involvement / </span>Designer and developer collaborating with marketing team at Mouser Electronics</p>
                                        <p><span  className={"semibold"}>Deliverables / </span>Interactive infographic</p>
                                        <p><span  className={"semibold"}>UX activities / </span>User research, personas, user journey</p>
                                        <p><span  className={"semibold"}>Tools used / </span>Figma, Lottie, Adobe After Effects, Adobe Illustrator, Miro, pen and paper</p>
                                        <p><span  className={"semibold"}><span style={{marginRight: 4}}><FontAwesomeIcon icon={faAward} style={{fontSize: 20}}/></span>Award / </span><a href={"https://enter.amcpros.com/marcom/entry/smart-home-infographic/"} style={{outlineOffset: 4, borderRadius: 2}}>MarCom Platinum Award for Creativity & Design<span style={{marginLeft: 4}}><FontAwesomeIcon icon={faExternalLink} style={{fontSize: 12}}/></span></a></p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12} lg={9}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"} style={{scrollMarginTop:72}}>Overview</p>
                                        <h2 className={"h3"}>Background</h2>
                                        <p>In my time as a digital designer at Mouser Electronics, I designed this infographic for Renesas to help inform engineers of their latest smart home products, the RA4M1 32-Bit Microcontrollers.</p>
                                        <p style={{margin:0}}>Renesas wanted to emphasize that their new microcontroller helps engineers design secure and feature-rich IoT devices by simplifying advanced functionality.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container d-none d-md-block"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Design process</h2>
                                        <img src={DesignProcess} alt={"Design process: brainstorm, research, analysis, design, user testing, delivery; contains multiple iterations of analysis, design, and user testing."} style={{maxWidth: 900, borderRadius: 0}}></img>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>

                <WorkSection className={"grey"} id={"general-research"} ref={generalResearchRef} style={{scrollMarginTop: getScrollMarginTop(generalResearchRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>General research</p>
                                        <h2 className={"h3"}>Target audience</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                <div className={"insights-container"}>
                                                    <Insight
                                                        number={"01"}
                                                        title={"Engineers"}
                                                        description={"Embedded systems engineers designing connected smart home devices"}>
                                                    </Insight>
                                                </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>

                <WorkSection id={"user-research"} ref={userResearchRef} style={{scrollMarginTop: getScrollMarginTop(userResearchRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>User research</p>
                                        <h2 className={"h3"}>Pain points</h2>
                                        <Container>
                                            <Row >
                                                <Col xs={12} className={"col-md-left"}>
                                                    <div className={"pain-points-container"}>
                                                        <PainPoint
                                                            src={TargetAudiencePink}
                                                            alt={""}
                                                            quote1={"“Every time a new wireless standard comes out, "}
                                                            semibold={"it feels like I’m starting over"}
                                                            quote2={". I just want one platform that can adapt as things evolve.”"}
                                                        ></PainPoint>
                                                        <PainPoint
                                                            src={TargetAudienceOrange}
                                                            alt={""}
                                                            quote1={"“I need a product that "}
                                                            semibold={"works with many different IoT applications"}
                                                            quote2={".”"}
                                                        ></PainPoint>
                                                        <PainPoint
                                                            src={TargetAudienceBlue}
                                                            alt={""}
                                                            quote1={"“Our design cycles are too long. Having "}
                                                            semibold={"advanced security built into the hardware"}
                                                            quote2={" would streamline development and help us speed through certification.”"}
                                                        ></PainPoint>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Personas</h2>
                                        <div className={"personas-container"}>
                                            <Persona src={Persona1} alt={""} name={"Carlos"} className={"interests aspirations frustrations"} demographics={persona1Demographics} interests={persona1Interests} aspirations={persona1Aspirations} frustrations={persona1Frustrations}>
                                            </Persona>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"challenge"} className={"challenge dark-background"} ref={challengeRef} style={{scrollMarginTop: getScrollMarginTop(challengeRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12} lg={9}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Challenge</p>
                                        <h2 className={"h3"}>Problem statement</h2>
                                        <p className={"no-margin description"}>Engineers are currently unaware of the Renesas RA4M1 32-Bit Microcontrollers. They need to be convinced of the benefits and technical advantages of adopting this solution for their next smart home project.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id="analysis" className={"grey"} ref={analysisRef} style={{scrollMarginTop: getScrollMarginTop(analysisRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Analysis</p>
                                        <h2 className={"h3"}>User journey</h2>
                                        <img src={UserJourney} alt={""} style={{borderRadius:0, maxWidth: 750}}></img>
                                        <div className={"sr-only"}>
                                            <h3>Awareness</h3>
                                            <ul>
                                                <li>Action: Clicks infographic link from email</li>
                                                <li>Thought: "I hope this gives me clear info without having to dig through tons of docs"</li>
                                                <li>Pain points: Overwhelmed by overly technical or cluttered product pages in the past</li>
                                                <li>UX needs: Clear visuals, concise text, and easy-to-understand benefits</li>
                                            </ul>
                                            <h3>Exploration</h3>
                                            <ul>
                                                <li>Action: Reviews the infographic, scanning key info</li>
                                                <li>Thoughts: "This seems like it could help me speed up development and improve device security"</li>
                                                <li>Pain points: Skeptical of marketing claims, wants proof and clear benefits</li>
                                                <li>UX needs: Transparent data with sources documented</li>
                                            </ul>
                                            <h3>Evaluation</h3>
                                            <ul>
                                                <li>Action: Looks for support and compatibility info</li>
                                                <li>Thoughts: "If the middleware is solid, this could really cut down on integration time</li>
                                                <li>Pain points: Lack of robust SDKs and sample code in past projects has delayed him before</li>
                                                <li>UX needs: Links to resources to learn more</li>
                                            </ul>
                                            <h3>Adoption</h3>
                                            <ul>
                                                <li>Action: Recommends product for next smart home project</li>
                                                <li>Thoughts: "This product fits our need for security, power efficiency, and flexible wireless support"</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"iterations"} className={"design-iterations"} ref={iterationsRef} style={{scrollMarginTop: getScrollMarginTop(iterationsRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Design iterations</p>
                                        <h2 className={"h3"}>Sketches</h2>
                                        <img src={Sketches} alt={""} style={{maxWidth: 400}}></img>
                                        <p className={"img-caption"} style={{marginBottom: 16}}>Sketches of the interactive infographic design.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h3 className={"h4 section-title"}>Insights</h3>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <p>Since this project was primarily focused on smart home applications of the product, I designed the page in a single scene with industry trends floating in the sky above a house and product information in the grass below.</p>
                                                    <p>I planned for the following in the final design:</p>
                                                    <div className={"insights-container"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"Pleasant microinteractions"}
                                                            description={"Animations and hover effects that guide the user's attention and encourage exploration across the infographic."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"Interactive elements"}
                                                            description={"Clickable icons within the house that reveal more information about potential product applications."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"03"}
                                                            title={"Clean layout"}
                                                            description={'Simple design with a clear information hierarchy and uncluttered visuals to improve readability.'}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"final-design"} className={"final-design grey"} ref={finalDesignRef} style={{scrollMarginTop: getScrollMarginTop(finalDesignRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Final design</p>
                                        <h2 className={"h3"}>Final deliverables</h2>
                                        <p>To interact with elements and see animations, <a href={"https://www.mouser.com/renesas-smart-home-infographic/"} style={{outlineOffset: 4, borderRadius: 2}} target={"_blank"} rel="noreferrer">view the full interactive infographic<span style={{marginLeft: 4}}><FontAwesomeIcon icon={faExternalLink} style={{fontSize: 12}}/></span></a></p>
                                        <img src={Final} alt={""} style={{maxWidth: 800}}></img>
                                        <p className={"img-caption"}>Final design of the interactive infographic.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"reflections"} className={"reflections dark-background"} ref={reflectionsRef} style={{scrollMarginTop: getScrollMarginTop(reflectionsRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Reflections</p>
                                        <h2 className={"h3"}>What I learned</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <div className={"insights-container"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"Refining animation skills"}
                                                            description={"I used a combination of Adobe After Effects and Lottie to create smooth animations to accompany the industry trends."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"Translating technical complexity"}
                                                            description={"I am no expert on engineering, so this project required some research on my part to ensure I was accurately portraying the necessary information."}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection className={"recommendations"} id="reflections">
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Explore other projects</h2>
                                        <Container>
                                            <Row style={{rowGap: 24, justifyContent: "space-between"}}>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={SouthwestThumbnail}
                                                        alt={"Three screens from the redesigned Southwest Airlines app"}
                                                        title={"Southwest Airlines"}
                                                        description={"App redesign (concept)"}
                                                        href={"/southwest-app-redesign"}>
                                                    </WorkRecommendation>
                                                </Col>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={DignifiThumbnail}
                                                        alt={"Three screens from the Dignifi app"}
                                                        title={"Dignifi"}
                                                        description={"App design"}
                                                        href={"/dignifi-app-design"}>
                                                    </WorkRecommendation>
                                                </Col>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={InsightThumbnail}
                                                        alt={"Prototype of the InSight AR device and one screen from the InSight app"}
                                                        title={"InSight"}
                                                        description={"AR experience and app design"}
                                                        href={"/insight-ar-app-design"}>
                                                    </WorkRecommendation>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
            </div>
        </main>
    )
}

export default SmartHomeInfographic;